<div class="backdrop">
    <div class="modal" [class.isOut]="viewIsOut">
        @if(profile && avatars){
        <div class="modal-header">
            <span class="title">PROFILE SETUP</span>
        </div>

        <div class="gray-box">
            <form class="user-name-container" [formGroup]="nameChangeForm">
                <div class="input-label-wrapper">
                    <span class="label-name">set username </span>
                    <span class="min-length">min {{minInputLength}} characters</span>
                </div>
                <div class="sopo-input name-input" (click)="handleErrorMessageHide()">
                    <input class="" formControlName="username" name="username" type="text" id="usernameInput"
                        [defaultValue]="displayName" (input)="handleInputChange($event)" [maxlength]="maxInputLength" />
                    <span class="counter" [ngClass]="{
                        'error': characterCount < minInputLength,
                    }">
                        {{ characterCount + "/" + maxInputLength }}
                    </span>

                    @if(nameIsAlreadyTakenError){
                    <span class="name-is-taken-error">
                        Username is taken. Please enter another.
                    </span>
                    }
                </div>
            </form>

            @for (validation of validationMessages.name; track validation.type) {
                @if (nameChangeForm.get('username').hasError(validation.type) && nameChangeForm.dirty) {
                    <div class="validation-error">
                        {{ validation.message }}
                    </div>
                }
            } @empty { }

            <span class="input-footer">
                You can change your username once every 30 days in <span class="decorated">Profile.</span>
            </span>
        </div>

        <div class="gray-box avatars-holder">
            <span class="box-title">choose avatar</span>
            <div class="avatar-box">
                @for (avatarItem of avatars; track avatarItem.id) {
                <div class="placeholder" [ngClass]="{'active': selectedAvatar.id === avatarItem.id}"
                    (click)="handleAvatarSelect(avatarItem)" [style]="'background-image: url('+ avatarItem.url +')'">
                </div>
                }
            </div>
        </div>
        <div class="info-icon-box">
            <div class="info-container">
                <img class="info-image" src="../../../../assets/icon/tabs/profile_yellow.png" alt="wallet" draggable="false">
                <span class="description">Switch avatars, change felts, adjust bet presets, and more in
                    <span class="decorated">Profile!</span>
                </span>
            </div>
            <div class="info-container">
                <img class="info-image" src="../../../../assets/icon/tabs/shop_yellow.png" alt="shop" draggable="false">
                <span class="description">Purchase more avatars in the <span class="decorated">Shop!</span>
                    New avatars are available every day.
                </span>
            </div>

        </div>
        <div class="button-container">
           <div class="save-button" (click)="handleProfileSetup()" [ngClass]="{
               'sopo-popup-grey-button': nameChangeForm.invalid || characterCount < minInputLength,
               'sopo-popup-green-button': nameChangeForm.valid && characterCount >= minInputLength
           }">Save</div>
       </div>

        } @else {
            <div class="loading-spinner">
                <ion-spinner></ion-spinner>
            </div>
        }
    </div>


</div>
